import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useTopList = (eventId) => {
    const baseUrl = useSelector((state) => state.baseURL);
    const [toplist, setToplist] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    async function fetchData() {
        const fullUrl = baseUrl.concat(
            `/api/public/transaction/event/${eventId}/projectids-with-most-transactions-last-6-hours`
        );
        const response = await fetch(fullUrl);
        const json = await response.json();
        setIsLoading(false);
        setToplist(json?.projectIds);
    }

    useEffect(() => {
        fetchData();
    }, [eventId]);

    return { toplist, isLoading };
};
